import {Switch} from "@progress/kendo-react-inputs"
import {useInternationalization} from "@progress/kendo-react-intl"
import dayjs from "dayjs"
import {MDBCol, MDBModalFooter, MDBRow} from "mdbreact"
import React from "react"
import {useLocation} from "react-router-dom"
import {
    fetchBookingUpdateInfo,
    sendEmailReminderCall,
    sendReminderCall,
    showBookingLogModal,
} from "../../../containers/MotBooking/bookingSlice"
import {useAppDispatch} from "../../../store"

const TestBookingFooter = ({
    bookingID,
    updatedBy,
    updatedDate,
    reminderCall,
    testStart,
    sendreminderEmail,
    isEmailEmpty,
}: {
    bookingID: number
    updatedBy: string
    updatedDate: string
    reminderCall: boolean
    testStart: string
    sendreminderEmail: boolean
    isEmailEmpty: boolean
}) => {
    const dispatch = useAppDispatch()
    const intl = useInternationalization()
    const location = useLocation()
    const openLogInfo = (e: any, bookingID: any) => {
        e.preventDefault()
        dispatch(showBookingLogModal(true))
        dispatch(fetchBookingUpdateInfo(bookingID))
    }

    return (
        <MDBModalFooter id="bk-test-footer" className="bg-light position-absolute p-2 bottom-0 w-100">
            <MDBRow className="w-100">
                <MDBCol>
                    {bookingID > 0 && (
                        <div>
                            <span className="font-weight-bold text-muted">
                                Last updated by &nbsp;
                                <a
                                    style={{
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                    }}
                                    onClick={event => openLogInfo(event, bookingID)}
                                >
                                    {updatedBy}
                                </a>
                            </span>
                            &nbsp;on
                            <span className="font-weight-bold text-muted">
                                &nbsp;{intl.formatDate(new Date(updatedDate))}
                                &nbsp;
                                {intl.formatDate(new Date(updatedDate), "HH:mm")}
                            </span>
                        </div>
                    )}
                </MDBCol>
                <MDBCol md="6">
                    <div className="d-flex align-items-center justify-content-end">
                        {!isEmailEmpty && (
                            <div className="me-3">
                                <Switch
                                    id="sendreminderEmail"
                                    className="me-3"
                                    onChange={e => {
                                        bookingID > 0 &&
                                            dispatch(sendEmailReminderCall(bookingID, e.value, location.pathname))
                                    }}
                                    checked={sendreminderEmail}
                                />
                                <span>Email Reminder &nbsp;</span>
                            </div>
                        )}
                        {bookingID > 0 && (
                            <>
                                <Switch
                                    id="reminderCall"
                                    className="me-3"
                                    onChange={() => {
                                        dispatch(sendReminderCall(bookingID, reminderCall, location.pathname))
                                    }}
                                    checked={reminderCall}
                                />
                                <span>Reminder Call - &nbsp;</span>
                                {reminderCall ? (
                                    <span className="font-weight-bold text-success">Called</span>
                                ) : dayjs(testStart).diff(dayjs(), "hour") > 0 && !reminderCall ? (
                                    <span className="font-weight-bold text-danger">Pending</span>
                                ) : (
                                    <span className="font-weight-bold text-muted">N/A</span>
                                )}
                            </>
                        )}
                    </div>
                </MDBCol>
            </MDBRow>
        </MDBModalFooter>
    )
}

export default React.memo(TestBookingFooter)
